"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Skeleton = _interopRequireDefault(require("../skeleton/Skeleton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CardSkeleton = function CardSkeleton() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-skeleton-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-top"
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    count: 1,
    height: "24px"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-middle"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-left"
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    count: 1,
    height: "112px",
    width: "115px"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-right"
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    count: 3,
    height: "20%",
    customStyle: {
      margin: '8px 0px'
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-card-item-bottom"
  }, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    count: 1,
    height: "24px"
  })));
};
var _default = exports.default = CardSkeleton;